export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const maskMobileNumber = (mobile) => {
  if (!mobile || mobile.length < 8) return mobile;

  const countryCode = mobile.slice(0, 3);
  const number = mobile.slice(3);
  // +91 123****456
  return `${countryCode} ${number.slice(0, 2)}****${number.slice(-4)}`;
};
